import styled from "styled-components";

export const FormContainer = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  padding: 2rem;
  border-radius: 16px;
  background: var(--surface-glass);
  backdrop-filter: blur(20px);
  border: 2px solid var(--border-subtle);
  width: 100%;
  max-width: 500px;
  margin: 1rem auto 0;
  align-self: center;
  box-sizing: border-box;
`;

export const FormRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const Label = styled.label`
  color: var(--text-heading);
  font-weight: 500;
  font-size: 0.95rem;
`;

export const Input = styled.input`
  padding: 0.75rem 1rem;
  border: 2px solid var(--border-default);
  border-radius: 12px;
  background: var(--surface-glass);
  color: var(--accent-secondary);
  font-size: 1rem;
  outline: none;
  transition: border-color 0.2s;

  &::placeholder {
    color: var(--input-placeholder);
  }

  &:focus {
    border-color: var(--accent);
  }
`;

export const Select = styled.select`
  padding: 0.75rem 1rem;
  border: 2px solid var(--border-default);
  border-radius: 12px;
  background: var(--surface-glass);
  color: var(--accent-secondary);
  font-size: 1rem;
  outline: none;
  cursor: pointer;

  option {
    background: var(--surface-1);
    color: var(--accent-secondary);
  }
`;

export const CheckboxWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const Checkbox = styled.input`
  width: 18px;
  height: 18px;
  accent-color: var(--accent);
  cursor: pointer;
`;

export const FileInputWrapper = styled.div`
  input[type="file"] {
    padding: 0.5rem;
    color: var(--text-heading);
    font-size: 0.9rem;

    &::file-selector-button {
      padding: 0.5rem 1rem;
      margin-right: 1rem;
      border: 2px solid var(--border-default);
      border-radius: 8px;
      background: var(--accent-soft);
      color: var(--accent-secondary);
      cursor: pointer;
      font-size: 0.9rem;
    }
  }
`;

export const ModeTabs = styled.div`
  display: flex;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
`;

export const ModeTab = styled.button`
  flex: 1;
  padding: 0.75rem 1rem;
  border: 2px solid ${(p) => (p.$active ? "var(--accent)" : "var(--border-subtle)")};
  border-radius: 12px;
  background: ${(p) => (p.$active ? "var(--accent-soft)" : "transparent")};
  color: var(--accent-secondary);
  font-size: 0.95rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    border-color: var(--accent);
    background: var(--accent-soft);
  }
`;

export const BboxPreview = styled.p`
  font-size: 0.9rem;
  color: var(--text-heading);
  margin: 0;
  font-family: monospace;
  padding: 0.5rem;
  background: var(--accent-soft);
  border-radius: 8px;
`;

export const ErrorText = styled.p`
  color: var(--danger);
  font-size: 0.9rem;
  margin: 0;
`;
